module.exports = __webpack_public_path__ + "img/icon_win_en.acc756b0.png";